import Payment from "payment";

function clearNumber(value = "") {
  return value.replace(/\D/g, "");
}

export function formatCreditCardNumber(value:any) {
  if (!value) {
    return value;
  }
  const issuer = Payment.fns.cardType(value);
  const clearValue = clearNumber(value);
  let nextValue;
  switch (issuer) {
    case "amex":
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4,10)} ${clearValue.slice(10, 15)}`;
      break;
    default:
      nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4,8)} ${clearValue.slice(8, 12)} ${clearValue.slice(12, 16)}`;
      break;
  }
  return nextValue.trim();
}

export function formatCVC(value:any, allValues:any = {}) {
  if (!value) {
    return value;
  }

  const clearValue = clearNumber(value);
  let maxLength = 4;

  if (allValues.number) {
    const issuer = Payment.fns.cardType(allValues.number);
    maxLength = issuer === "amex" ? 4 : 3;
  }

  return clearValue.slice(0, maxLength);
}

export function formatExpirationDate(value:any) {
  if (!value) {
    return value;
  }

  let clearValue = clearNumber(value);

  if (clearValue.length >= 3) {
    return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
  }
  if (clearValue.length === 1 && value > 1) {
    clearValue = "0" + value;
  }
  // bounds
  if (value === "00") {
    clearValue = "01";
  } else if (value > 12) {
    clearValue = "12";
  }
  return clearValue;
}

export function formatFormData(data:any) {
  return Object.keys(data).map(d => `${d}: ${data[d]}`);
}
